import {h, Fragment} from 'preact';
import { useState } from "preact/hooks";
import SelectBankCardForm from "./SelectBankCardForm";
import {formatPriceWithSymbol} from "../../tools";

export default function GroupModalDialog({ setIsOpen, handlerPay, modalDialogParams, bankCards, bankCardId, onChangeBankCard, saveBankCard, changeSaveBankCard, isTerminal}){
	const devices = modalDialogParams.items;
	const container = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: 'rgba(0,0,0,0.5)',
		zIndex: 1000
	}

	const modal = {
		backgroundColor: 'white',
		padding: '20px',
		borderRadius: '10px',
		width: '500px',
		display: 'table',
		boxShadow: '0px 0px 10px #cccccc'
	}

	function handleClick() {
		document.removeEventListener('keydown', keyDownEscape);
		setIsOpen(false);
	}

	function handlePay() {
		handlerPay();
	}

	function keyDownEscape(event) {
        if (event.key === 'Escape') {
            const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
            if (isNotCombinedKey) {
                handleClick();
            }
        }
	}

	document.addEventListener('keydown', keyDownEscape);
	return (
		<div style={container}>
			<div style={modal}>
				<div style={{float: 'right'}}>
					<button onClick={handleClick}>
						<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
							<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="black"></path>
						</svg>
					</button>
				</div>
				<div>
					<div>
						<h3 className="banner__title">Внимание!</h3>
						По адресу:<br/>
						{devices.map((device) => {
							return (
								<Fragment>
									<span style={{color: '#1A47A9'}}>{device.address}</span><br/>
								</Fragment>
							);
						})}
						<br/>не переданы показания по прибору учета, передайте показания перед оплатой.
					</div>

					<div style={{
						paddingTop: 20,
						paddingLeft: 20,
						paddingRight: 20,
						margin: "20px -20px 0",
						borderTop: "1px solid #E7EAEF"
					}}>
						{false && !isTerminal && (
							<SelectBankCardForm
								bankCards={bankCards}
								bankCardId={bankCardId}
								onChangeBankCard={bankCardId => onChangeBankCard(bankCardId)}
								saveBankCard={saveBankCard}
								changeSaveBankCard={value => changeSaveBankCard(value)}
							/>
						)}
						<button className="button-primary button-primary_bgc_brand-2 form-block__footer-item" onClick={handlePay}>
							<span className="button-primary__icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.333 2.66667H2.66634C1.92634 2.66667 1.33967 3.26 1.33967 4L1.33301 12C1.33301 12.74 1.92634 13.3333 2.66634 13.3333H13.333C14.073 13.3333 14.6663 12.74 14.6663 12V4C14.6663 3.26 14.073 2.66667 13.333 2.66667ZM13.333 12H2.66634V8H13.333V12ZM13.333 5.33334H2.66634V4H13.333V5.33334Z" fill="#1A47A9"/></svg></span><span className="button-primary__text">Оплатить</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}
